/**
 * Copyright (c) 2019-2021 2022 AIGIA All Rights Reserved.
 */

"use strict";

import {Component, OnChanges, OnInit} from "@angular/core";

import {FormBuilder, Validators} from "@angular/forms";

import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";

import {intersectionBy} from "lodash";

import {ShotdataService} from "../../shotdata/shotdata.service";
import {SessionService} from "../../../platform/base/services/session.service";

import {animate, state, style, transition, trigger} from "@angular/animations";

import {ListBaseComponent} from "./list-base.component";
import {ShotScoreService} from "../shot-score.service";
import {Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";

/**
 * todo
 */
@Component({
	selector: "aigia-list",
	templateUrl: "./list.component.html",
	styleUrls: ["../floating/floating.component.css", "./list.component.css"],
	animations: [
		trigger("sorter_slide", [
			state("sorter_slide_start", style({left: "0px"})),
			state("sorter_slide_end", style({left: "300px"})),
			transition("sorter_slide_start <=> sorter_slide_end", animate("0.4s ease-out")),
		]),
		trigger("finder_slide", [
			state("finder_slide_start", style({left: "0px"})),
			state("finder_slide_end", style({left: "300px"})),
			transition("finder_slide_start <=> finder_slide_end", animate("0.4s ease-out")),
		]),
	],
})

export class ListComponent extends ListBaseComponent implements OnChanges, OnInit {

	/**
	 * @returns none
	 */
	public get isProgress(): boolean {
		return false;
	}

	constructor(
		public listservice: ShotdataService,
		public session: SessionService,
		public matDialog: MatDialog,
		public snackbar: MatSnackBar,
		public formBuilder: FormBuilder,
		protected shotscore: ShotScoreService,
		protected router: Router,
		public translate: TranslateService,
	) {
		super(listservice, session, matDialog, snackbar, formBuilder, shotscore, router,translate);
	}

	/**
	 * @returns none
	 */
	public ngOnInit(): void {
		this.range = this.formBuilder.group({
			start: [0, [Validators.required, Validators.min(0)]],
			count: [12, [Validators.required, Validators.min(1), Validators.max(12)]],
		});
	}

	/**
	 * @returns none
	 */
	public ngOnChanges(changes: any): void {
		if (this.shots.length > 0) {
			this.selected.push(this.shots[0]);
		}

		this.Progress(true);
		this.buildQuery(this.data);
		this.buildOption();
		this.draw((error, result): void => {
			this.Progress(false);
		});
		this.selected = intersectionBy(this.selected, '_id');
	}

}
